export default "__VITE_ASSET__0VieSOwg__"